import React, { forwardRef } from "react";

import styles from "../Styles/ui/Table.module.css";

const Table = forwardRef(({ className, ...props }, ref) => (
  <div className={styles.tableContainer}>
    <table ref={ref} className={`${styles.table} ${className || ""}`} {...props} />
  </div>
));
Table.displayName = "Table";

const TableHeader = forwardRef(({ className, ...props }, ref) => (
  <thead ref={ref} className={`${styles.tableHeader} ${className || ""}`} {...props} />
));
TableHeader.displayName = "TableHeader";

const TableBody = forwardRef(({ className, ...props }, ref) => (
  <tbody ref={ref} className={`${styles.tableBody} ${className || ""}`} {...props} />
));
TableBody.displayName = "TableBody";

const TableFooter = forwardRef(({ className, ...props }, ref) => (
  <tfoot ref={ref} className={`${styles.tableFooter} ${className || ""}`} {...props} />
));
TableFooter.displayName = "TableFooter";

const TableRow = forwardRef(({ className, ...props }, ref) => (
  <tr ref={ref} className={`${styles.tableRow} ${className || ""}`} {...props} />
));
TableRow.displayName = "TableRow";

const TableHead = forwardRef(({ className, ...props }, ref) => (
  <th ref={ref} className={`${styles.tableHead} ${className || ""}`} {...props} />
));
TableHead.displayName = "TableHead";

const TableCell = forwardRef(({ className, ...props }, ref) => (
  <td ref={ref} className={`${styles.tableCell} ${className || ""}`} {...props} />
));
TableCell.displayName = "TableCell";

const TableCaption = forwardRef(({ className, ...props }, ref) => (
  <caption ref={ref} className={`${styles.tableCaption} ${className || ""}`} {...props} />
));
TableCaption.displayName = "TableCaption";

export {
  Table,
  TableHeader,
  TableBody,
  TableFooter,
  TableHead,
  TableRow,
  TableCell,
  TableCaption,
};
